export type NotificationCategory = 'alerts' | 'markets' | 'news';

export type AlertSettingKey =
	| 'liquidationAlert'
	| 'liquidationWarning'
	| 'orderTriggered'
	| 'orderFilled'
	| 'positionClosed';

export type MarketSettingKey = 'delistNotice' | 'newMarket';

export type NotificationSettingKey =
	| AlertSettingKey
	| MarketSettingKey
	| 'newsAndAnnouncements';

export type NotificationSettingsState = Record<NotificationSettingKey, boolean>;

export type AlertType = 'fundingRiseAbove' | 'fundingFallBelow';
export type AlertFrequency = 'onlyOnce' | 'oncePerDay' | 'always';

export interface FundingRateAlert {
	id: string;
	marketSymbol: string;
	marketIndex: number;
	alertType: AlertType;
	thresholdPercent: number;
	frequency: AlertFrequency;
	createdAt: number;
}

export interface NotificationToastItem {
	id: string;
	category: NotificationCategory;
	title: string;
	icon: 'warning' | 'success' | 'market' | 'info';
	ctaRoute?: string;
	timestamp: number;
}

export type SettingsView =
	| { screen: 'settings' }
	| { screen: 'fundingRateAlertList' }
	| { screen: 'createAlert' };

export const ALERT_TYPE_LABELS: Record<AlertType, string> = {
	fundingRiseAbove: 'Funding Rise Above',
	fundingFallBelow: 'Funding Fall Below',
};

export const ALERT_FREQUENCY_LABELS: Record<AlertFrequency, string> = {
	onlyOnce: 'Only Once',
	oncePerDay: 'Once per day',
	always: 'Always',
};

export const MAX_FUNDING_RATE_ALERTS = 5;
